module.exports = __webpack_public_path__ + "static/media/icon_box_3d_default.70f21666.svg";